import { useCallback, useMemo } from 'react';

const isLocalStorageEnabled = () => {
  try {
    localStorage.setItem('test', 'test');
    localStorage.removeItem('test');
    return true;
  } catch {
    return false;
  }
};

const useLocalStorage = (keys) => {
  const isEnabled = useMemo(() => isLocalStorageEnabled(), []);

  const getItem = useCallback((key) => (
    (isEnabled && keys.includes(key)) ? localStorage.getItem(key) : null
  ), [isEnabled, keys]);

  const setItem = useCallback((key, value) => {
    if (isEnabled && keys.includes(key)) {
      localStorage.setItem(key, value);
    }
  }, [isEnabled, keys]);

  const clear = useCallback(() => {
    if (isEnabled) {
      keys.forEach((key) => localStorage.removeItem(key));
    }
  }, [isEnabled, keys]);

  return { getItem, setItem, clear };
};

export default useLocalStorage;
